"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isChannel = void 0;
const isChannel = (item) => (item === null || item === void 0 ? void 0 : item.channelId) && (item === null || item === void 0 ? void 0 : item.environmentId);
exports.isChannel = isChannel;
//# sourceMappingURL=channels.js.map